import { configureStore } from "@reduxjs/toolkit";
import mapReducer from "./slices/mapApiSlice.ts"
import filterReducer from "./slices/filterSectionSlice.ts"
import loginReducer from "./slices/loginApiSlice.ts"
import  countrySlice from "./slices/countryApiSlice.ts"

export const store = configureStore({
  reducer: {
    map: mapReducer,
    filter:filterReducer,
    login: loginReducer,
    country: countrySlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
